import { render, staticRenderFns } from "./PickupDetails.vue?vue&type=template&id=26885563&scoped=true"
import script from "./PickupDetails.vue?vue&type=script&lang=js"
export * from "./PickupDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26885563",
  null
  
)

export default component.exports